export default __webpack_public_path__ + "static/media/iconMapPinWhite.3a15b5f0.svg";